import { useDispatch, useSelector } from 'react-redux';
import { isSmartPhone } from '../../utilities/helper';
import View from '../view';
import './index_web.css';
import { useLink } from 'react-router-stack';
import HeaderMWeb from './index_mWeb';
import avatars from '../../constants/avatars';
import useTheme from '../../utilities/hooks/theme';
import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar/Avatar';
import Text from '../text';
import { MdLogout } from 'react-icons/md';
import { IoMdArrowDropdown } from 'react-icons/io';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { userLogOut } from '../../actions/user-actions-types';
import Constants from '../../constants';
import { showToast } from '../../actions/app-actions-types';

const HeaderWeb = ({
  isWelcomeMessage,
  xpCoinContainerStyle,
  logInBtnStyle,
  signUpBtnStyle,
  avatarId,
  teamName,
  balance,
  xpPoints,
  openLogInModal,
  openSignUpModal
}: any) => {
  const { DashboardTheme: theme } = useTheme();
  const dispatch = useDispatch();
  let { themeType = '' } = useSelector((state: any) => state.setting);
  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useLink();
  if (isSmartPhone) {
    return <HeaderMWeb isWelcomeMessage={isWelcomeMessage} />;
  }
  const headerStyle = {
    backgroundImage: themeType === 'dark' ? theme.dashBoardHeaderBackground : '',
    backgroundColor: themeType !== 'dark' ? theme.dashBoardHeaderBackground : '',
    borderBottom: `2px solid ${theme.dashBoardHeaderSeperatorBg}`
  };

  const onPressAddress = (e: any) => {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };
  const profileContainerStyle = {
    background: theme.profileContainerBg,
    boxShadow: theme.profileContainerBoxShadow
  };

  const handleLogOut = () => {
    dispatch(userLogOut());
    dispatch(showToast('Logged Out Successfully'));
  };
  return (
    <View className="header_wrapper" style={headerStyle}>
      <div className="header_user_welcome">
        {isWelcomeMessage && teamName && `${!isSmartPhone ? 'Welcome' : ''} ${teamName}`}
      </div>
      <div className="header_user_info_wrapper">
        {!teamName && (
          <div className="utility-area_web">
            <button
              className="header__login__signUp__btn"
              style={logInBtnStyle}
              onClick={openLogInModal}>
              Log In
            </button>
            <button
              className="header__login__signUp__btn"
              style={signUpBtnStyle}
              onClick={openSignUpModal}>
              Sign Up
            </button>
          </div>
        )}
        {teamName && (
          <React.Fragment>
            <div className="header__coin__container__web" style={xpCoinContainerStyle}>
              <img src={Constants.Images.xp} width={30} />
              <Text className="header__xp__coins__txt">{xpPoints}</Text>
            </div>
            <div className="header__xp__container__web" style={xpCoinContainerStyle}>
              <img className="header__Coins__img" src={Constants.Images.coin} />
              <Text className="header__xp__coins__txt">{balance['totalBalance']}</Text>
              <img
                className="header__addCashPlus__img"
                src={Constants.Images.addCashPlus}
                width={'15px'}
              />
            </div>

            <div className={'dashboardWallet__cryptoWalletItem'} onClick={onPressAddress}>
              <View className="dashboardWallet__cryptoWalletSubItem" style={profileContainerStyle}>
                <Avatar
                  sx={{ width: 30, height: 30, borderWidth: 0 }}
                  onClick={() => navigate.push('/my_profile')}>
                  <img
                    // className="avatar_web"
                    width={'100%'}
                    height={'100%'}
                    id="av_tr_id"
                    src={avatars[avatarId]}
                    alt="User Logo"
                  />
                </Avatar>
                <Text className="dashboardWallet__cryptoWalletAddress">{teamName}</Text>
                <IoMdArrowDropdown color={'#000'} />
              </View>
              <div
                style={{
                  display: showDropdown ? 'block' : 'none'
                }}
                className={'dashboardWallet__DropDownContainer'}>
                <View
                  style={{
                    flexDirection: 'row'
                  }}
                  className={'dashboardWallet__DropDownItem'}
                  // onPress={onPressLogout}
                >
                  <View className="dashboardWallet__DropDownLogoutBtnContainer">
                    <View
                      style={{
                        flexDirection: 'row'
                      }}
                      onPress={handleLogOut}>
                      <MdLogout
                        className={'dashboardWallet__DropDownLogoutIcon'}
                        color={'#fff'}
                        size={20}
                      />
                      <Text className="dashboardWallet__DropDownLogoutBtn">{'Logout'}</Text>
                    </View>
                    <AiOutlineArrowRight
                      className={'dashboardWallet__DropDownBackIcon'}
                      color={'#fff'}
                      size={20}
                    />
                  </View>
                </View>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </View>
  );
};

export default HeaderWeb;
